function validateLVDateCode(dateCode) {
  //don't remove
  // const countryCodes = {
  //   A0: "France", A1: "France", A2: "France", AA: "France", AH: "France", AN: "France",
  //   AR: "France", AS: "France", BA: "France", BE: "France", BJ: "France", BU: "France",
  //   DR: "France", DU: "France", CO: "France", CT: "France", CV: "France", ET: "France", FL: "France", GR: "France",
  //   LM: "France", LA: "France", LW: "France", MB: "France", MI: "France", MS: "France", NO: "France", PT: "France",
  //   RA: "France", RE: "France", RI: "France", SA: "France", SD: "France", SF: "France", SL: "France",
  //   SN: "France", SP: "France", SR: "France", TJ: "France", TH: "France", TA: "France", TR: "France", TN: "France",
  //   TS: "France", TY: "France", VI: "France", VX: "France", WL: "France",
  //   LP: "Germany", OL: "Germany",
  //   BC: "Italy", BO: "Italy", CE: "Italy", FO: "Italy", MA: "Italy", PL: "Italy", FL: "Italy", CX: "Italy", DI: "Italy" , DP: "Italy" , DR: "Italy" , EA: "Italy" , LE: "Italy" , LK: "Italy" , OB: "Italy" ,
  //   RC: "Italy", RE: "Italy", SA: "Italy", TB: "Italy", TD: "Italy", NZ: "Italy", TE: "Italy", US: "Italy", GM: "Italy", MR: "Italy", IL: "Italy", IS: "Italy",
  //   AR: "Italy", BA: "Italy", BL: "Italy", BR: "Italy", BM: "Italy", CL: "Italy", DE: "Italy", EL: "Italy", FA: "Italy", FD: "Italy", GI: "Italy", GO: "Italy", JA: "Italy", LI: "Italy", MA: "Italy", MS: "Italy",
  //   MT: "Italy", ND: "Italy", NL: "Italy", NQ: "Italy", RO: "Italy", SC: "Italy", ST: "Italy", TC: "Italy",
  //   CA: "Spain", JJ: "Spain", LO: "Spain", LB: "Spain", LM: "Spain", LW: "Spain", AC: "Spain", BC: "Spain", BP: "Spain", CA: "Spain", CR: "Spain",
  //   GI: "Spain", UB: "Spain",
  //   DI: "Switzerland", FA: "Switzerland",
  //   FC: "USA", FH: "USA", LA: "USA", OS: "USA", SD: "USA", TX: "USA", FL: "USA"
  // };

    const countryCodes = {
    A0: ["France"], A1: ["France"], A2: ["France"], AA: ["France"], AAS: ["France"], AH: ["France"], AN: ["France"],
    AR: ["France", "Italy"], AS: ["France"], BA: ["France", "Italy"], BE: ["France"], BJ: ["France"], BU: ["France"],
    DR: ["France", "Italy"], DU: ["France"], CO: ["France"], CT: ["France"], CV: ["France"], ET: ["France"], 
    FL: ["France", "Italy", "USA"], GR: ["France"], DT: ["France"], MM: ["France"], SK: ["France"],
    LM: ["France"], LA: ["France", "USA"], LW: ["France", "Spain"], MB: ["France"], MI: ["France"], 
    MS: ["France", "Italy"], NO: ["France"], PT: ["France"],
    RA: ["France"], RE: ["France", "Italy"], RI: ["France"], SA: ["France", "Italy"], SD: ["France", "USA"], 
    SF: ["France"], SL: ["France"], SN: ["France"], SP: ["France"], SR: ["France"], TJ: ["France"], 
    TH: ["France"], TA: ["France"], TR: ["France"], TN: ["France"], TS: ["France"], TY: ["France"], 
    VI: ["France"], VX: ["France"], WL: ["France"],
    LP: ["Germany"], OL: ["Germany"],
    BC: ["Italy", "Spain"], BO: ["Italy"], CE: ["Italy"], FO: ["Italy"], MA: ["Italy"], PL: ["Italy"], FP: ["Italy"], 
    CX: ["France", "Italy"], DI: ["Italy", "Switzerland"], DP: ["Italy"], EA: ["Italy"], LE: ["Italy"], LK: ["Italy"], 
    OB: ["Italy"], RC: ["Italy"], TB: ["Italy"], TD: ["Italy"], NZ: ["Italy"], TE: ["Italy"], US: ["Italy"], 
    GM: ["Italy"], MR: ["Italy"], IL: ["Italy"], IS: ["Italy"], BL: ["Italy"], BR: ["Italy"], BM: ["Italy"], 
    CL: ["Italy"], DE: ["Italy"], EL: ["Italy"], FA: ["Italy", "Switzerland"], FD: ["Italy"], GI: ["Italy", "Spain"], 
    GO: ["Italy"], JA: ["Italy"], LI: ["Italy"], MS: ["Italy"], MT: ["Italy"], ND: ["Italy"], NL: ["Italy"], 
    NQ: ["Italy"], RO: ["Italy"], SC: ["Italy"], ST: ["Italy"], TC: ["Italy"],
    CA: ["Spain"], JJ: ["Spain"], LO: ["Spain"], LB: ["Spain"], LM: ["Spain"], LW: ["Spain"], AC: ["Spain"], 
    BC: ["Spain"], BP: ["Spain"], CR: ["Spain"], UB: ["Spain"],
    FC: ["USA"], FH: ["USA"], LA: ["USA"], OS: ["USA"], TX: ["USA"]
  };
  
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  function toOrdinal(num) {
    if (num > 10 && num < 20) return `${num}th`;
    const lastDigit = num % 10;
    if (lastDigit === 1) return `${num}st`;
    if (lastDigit === 2) return `${num}nd`;
    if (lastDigit === 3) return `${num}rd`;
    return `${num}th`;
  }

   function getLocation(factoryCode) {
    const countries = countryCodes[factoryCode];
    if (!countries) return null;
    return countries.join(" or ");
  }

  if (!dateCode) {
    return "Invalid date code.";
  }
  // Special Order Codes (e.g. AAS, AAS123, SPORD01)
  if (/^(AAS|SPORD\d*|[A-Z]{3,}\d*)$/.test(dateCode)) {
    const location = getLocation("AAS"); 
    return `Special Order code manufactured in ${location}.`;
  }

    // Early 1980s: 3–4 digits (YYM or YYMM)
  if (/^\d{3,4}$/.test(dateCode)) {
    const year = parseInt(dateCode.slice(0, 2), 10);
    const month = parseInt(dateCode.slice(2), 10);
    const fullYear = 1900 + year;
    return `Manufactured in ${monthNames[month - 1]} ${fullYear} (no specific factory code).`;
  }

    // Early/Mid 1980s: 2 letters + 3 digits (Factory + YYM)
    //if (/^[A-Z]{2}\d{3}$/.test(dateCode)) {
  if (/^(?:[A-Z]{2}|A[0-2]|AAS)\d{3}$/.test(dateCode)) {
    const factoryCode = dateCode.slice(0, 2);
    const numbers = dateCode.slice(2); // YYM
    const year = parseInt(numbers.slice(0, 2), 10);
    const month = parseInt(numbers.slice(2), 10);

    const location = getLocation(factoryCode);
    if (!location) return "Invalid factory code.";

    const fullYear = 1900 + year;
    return `Manufactured in ${location} in ${monthNames[month - 1]} ${fullYear}.`;
  }

    // Mid/Late 1980s: 3 digits + 2 letters (YYM + factory)
    //if (/^\d{3}[A-Z]{2}$/.test(dateCode)) {
  if (/^\d{3}(?:[A-Z]{2}|A[0-2]|AAS)$/.test(dateCode)) {
    const year = parseInt(dateCode.slice(0, 2), 10);
    const month = parseInt(dateCode.slice(2, 3), 10);
    const factoryCode = dateCode.slice(3);

    const location = getLocation(factoryCode);
    if (!location) return "Invalid factory code.";

    const fullYear = 1900 + year;
    const monthName = monthNames[month - 1];

    return `Manufactured in ${monthName} ${fullYear} in ${location}.`;
  }

    // Late 1980s: 4 digits + 2 letters (YYMM + factory)
   //if (/^\d{4}[A-Z]{2}$/.test(dateCode)) {
  if (/^\d{4}(?:[A-Z]{2}|A[0-2]|AAS)$/.test(dateCode)) {
    const year = parseInt(dateCode.slice(0, 2), 10);   // 87
    const month = parseInt(dateCode.slice(2, 4), 10);  // 11
    const factoryCode = dateCode.slice(4);             // SD

    const location = getLocation(factoryCode);
    if (!location) return "Invalid factory code.";

    const fullYear = 1900 + year;
    return `Manufactured in ${location} in ${monthNames[month - 1]} ${fullYear}.`;
  }
    // 1990–present: 2 letters + 4 digits
  //if (/^[A-Z]{2}\d{4}$/.test(dateCode)) {
  if (/^[A-Z0-9]{2}\d{4}$/.test(dateCode)) {
    const factoryCode = dateCode.slice(0, 2);
    const numbers = dateCode.slice(2);
    const location = getLocation(factoryCode);
    if (!location) return "Invalid country code.";

    let year, fullYear, monthOrWeek;

    // Late 1980s special case (YYMM after letters)
    if (parseInt(numbers.slice(0, 2), 10) >= 80 && parseInt(numbers.slice(0, 2), 10) <= 89) {
      year = parseInt(numbers.slice(0, 2), 10);
      fullYear = 1900 + year;
      monthOrWeek = parseInt(numbers.slice(2), 10);
      return `Manufactured in ${location} in ${monthNames[monthOrWeek - 1]} ${fullYear}.`;
    }

       // 1990–2006 (MMYY format)
    year = parseInt(numbers[1] + numbers[3], 10);
    fullYear = year >= 90 ? 1900 + year : 2000 + year;
    monthOrWeek = parseInt(numbers[0] + numbers[2], 10);

        if (fullYear >= 1990 && fullYear <= 2006) {
      if (monthOrWeek >= 1 && monthOrWeek <= 12) {
        return `Manufactured in ${location} in ${monthNames[monthOrWeek - 1]} ${fullYear}.`;
      }
    }

     // 2007–present (week/year format)
    if (fullYear >= 2007 && fullYear <= 2025) {
      if (monthOrWeek >= 1 && monthOrWeek <= 52) {
        return `Manufactured in ${location} during the ${toOrdinal(monthOrWeek)} week of ${fullYear}.`;
      }
    }
     return "Invalid date format.";
  }


  return "Unrecognized date code format.";
}


function submitLVDateCode() {
   const inputField = document.getElementById("datecode-id");
   const resultsDiv = document.getElementById("results");
   const codeElement = document.getElementById("code");
   const resultElement = document.getElementById("result");

  const dateCode = inputField.value.trim().toUpperCase();

   if (dateCode === "") {
        resultsDiv.style.display = "none"; 
        return;
    }
    const result= validateLVDateCode(dateCode);

     codeElement.textContent = `${dateCode}:`;
     resultElement.textContent = result;

      resultsDiv.style.display = "block";
  
}